<template>
  <div class="bg-grey py-5">
    <div class="kws-int-container">
      <h1 class="h1" v-text="translate('lblHeadline')"></h1>
      <div
        class="event-list bg-white"
        v-if="months.length && !error && !loading"
      >
        <event-month
          v-for="month in months"
          :key="month.date.toString()"
          :days="month.days"
          :monthDate="month.date"
        ></event-month>
      </div>
      <div v-if="!months.length && !error && !loading">
        <h2 v-text="translate('lblNoEventsFound')"></h2>
      </div>
      <p class="error-box" v-else-if="error" v-text="error"></p>
    </div>
    <loading-indicator v-if="loading && !error"></loading-indicator>
  </div>
</template>

<script>
import EventMixin from './mixins/EventMixin';
import EventMonth from './components/event-month.vue';
import LoadingIndicator from '../shared/components/loading-indicator.vue';

export default {
  name: 'EventList',
  components: {
    EventMonth,
    LoadingIndicator,
  },
  data: () => ({
    months: [],
    error: null,
    loading: false,
  }),
  props: {
    translations: Object,
    detailView: {
      type: String,
      required: true,
    },
    apiUrl: {
      type: String,
      required: true,
    },
    formatDateHeadline: {
      type: String,
      required: true,
    },
    formatDateDay: {
      type: String,
      required: true,
    },
    formatDateWeekday: {
      type: String,
      required: true,
    },
    formatStartDate: {
      type: String,
      required: true,
    },
    formatEndDate: {
      type: String,
      required: true,
    },
  },
  provide() {
    return {
      formatDateHeadline: this.formatDateHeadline,
      formatDateDay: this.formatDateDay,
      formatDateWeekday: this.formatDateWeekday,
      formatStartDate: this.formatStartDate,
      formatEndDate: this.formatEndDate,
      detailView: this.detailView,
    };
  },
  mixins: [EventMixin],
  methods: {
    formatData(result) {
      const campaigns = result?.data?.info?.Campaigns || [];
      const sortedCampaigns = campaigns.sort((a, b) => new Date(a.StartDate).getTime() - new Date(b.StartDate).getTime());

      let activeMonth = null;
      let activeDay = null;
      let lastMonth = 0;
      let lastDay = 0;

      sortedCampaigns.forEach((campaign) => {
        const campaignMomentStartDate = window.moment(
          new Date(campaign.StartDate),
        );
        const campaignMonth = campaignMomentStartDate.format('MM');
        const campaignDay = campaignMomentStartDate.format('DD');
        const isCampaignUpcoming = campaignMomentStartDate.isSameOrAfter(
          window.moment(),
          'day',
        );
        const isDifferentMonth = campaignMonth !== lastMonth;
        const isDifferentDay = campaignDay !== lastDay;

        if (!isCampaignUpcoming) {
          return;
        }
        if (isDifferentMonth) {
          activeMonth = {
            date: campaignMomentStartDate,
            days: [],
          };
          this.months.push(activeMonth);
        }
        if (isDifferentDay) {
          activeDay = {
            date: campaignMomentStartDate,
            events: [],
          };
          activeMonth.days.push(activeDay);
        }
        activeDay.events.push(this.renameObjectKeys(campaign));
        lastMonth = campaignMonth;
        lastDay = campaignDay;
      });
    },
  },
  async created() {
    if (this.translations) {
      this.addDictionary(this.translations);
    }
    this.formatData(await this.getEventData(`${this.apiUrl}/campaign/events/`));
  },
};
</script>

<style lang="scss">
.event-list {
  margin: 0 -1.6875rem;
  @media (min-width: rem(768px)) {
    margin: inherit;
  }
  h2 {
    padding: 10px 27px;
    font-size: 24px;
    border-bottom: 1px solid #d7d9db;
    margin: 0;
  }
}
</style>
